import sha1 from 'sha1';

export const hash = (data: string): string => {
	return sha1(data);
};
